<template>
  <div>
    <HeaderTop></HeaderTop>
    <div class="paperPage">
      <div class="mid">
        <div class="mianbao mt2 d-flex d-flex-between">
          <div class="bread">
            <span class="dq">当前位置：</span>
            <span @click="toRouter('/main/home')" class="mba  click">个人中心</span> &gt;
            <span @click="toRouter('/main/homework')" class="mba  click" v-if="type=='HOMEWORK'">综合评价作业</span>
            <span @click="toRouter('/main/exam')" class="mba  click" v-else>综合评价考试</span>
              &gt;
            <span class="site " >详情</span>
          </div>
          <el-button size="small" @click="goBack" class="backBtn">返回</el-button>
        </div>
        <div class="content">
          <div class="paperInfo">
            <p class="paperTitle">{{ paperData.name }}</p>
            <div class="descBox d-flex d-flex-middle d-flex-center">
              <p>课程: {{ paperData.courseCode+'-'+paperData.courseName }}</p>
              <p>考试时间：{{ paperData.duration }}分钟</p>
              <p>卷面总分：{{ paperData.totalScore }}分</p>
            </div>
            <div class="scoreTable" v-if="type=='EXAMINE'">
              <table border>
                <tr>
                  <td>题序</td>
                  <td v-for="(v, i) in sections" :key="i">
                    {{ numToCapital(i + 1) }}
                  </td>
                  <td>总分</td>
                </tr>
                <tr>
                  <td>得分</td>
                  <td v-for="(v, i) in sections" :key="i">-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>评卷人</td>
                  <td v-for="(v, i) in sections" :key="i"></td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
          <div class="paperBox">
            <div class="list">
              <div class="li" v-for="(item, index) in sections" :key="index">
                <div class="titleBox" v-if="item.questions">
                  <p>{{ index+1 }}、{{ item.name || item.questionType }} （本大题共{{item.questions.length}}小题，每小题{{ item.questions[0].score }}分，共{{item.questions[0].score * item.questions.length}}分）
                  </p>
                </div>
                <div
                  class="liBox"
                  v-for="(question, indexQ) in item.questions"
                  :key="'q' + indexQ"
                  :id="'Q-' + question.id"
                >
                  
                  <!-- 套题 -->
                  <template v-if="question.type == 'TT'">
                    <div class="title fontSize32">
                      ({{ Number(indexQ) + 1 }})、<span
                        v-html="reformHtml(question.content)"
                      ></span>
                    </div>
                    <div
                      class="boxView"
                      v-for="(q, qi) in question.children"
                      :key="'q_' + qi"
                    >
                      
                      <template
                        v-if="q.type == 'SINGLECHOICE' || q.type == 'MULTIPLECHOICE' || q.type == 'JUDGMENT'"
                      >
                        <choice
                          :info="q"
                          :no="qi"
                          @choose="change"
                          :readOnly="readOnly"
                        ></choice>
                      </template>
                      <template v-else-if="q.type == 'BLANKFILL'">
                        <blank
                          :info="q"
                          :no="qi"
                          :readOnly="readOnly"
                          @change="change"
                        ></blank>
                      </template>
                      <template v-else>
                        <essay
                          :info="q"
                          :no="qi"
                          :readOnly="readOnly"
                          @change="change"
                        ></essay>
                      </template>
                    </div>
                  </template>
                  <!-- 非套题 -->
                  <template v-else>
                    <template
                      v-if="
                        question.type == 'SINGLECHOICE' ||
                        question.type == 'MULTIPLECHOICE' ||
                        question.type == 'JUDGMENT'
                      "
                    >
                      <choice
                        :info="question"
                        :no="indexQ"
                        @choose="change"
                        :readOnly="readOnly"
                      ></choice>
                    </template>
                    <template v-else-if="question.type == 'BLANKFILL'">
                      <blank
                        :info="question"
                        :no="indexQ"
                        :readOnly="readOnly"
                        @change="change"
                      ></blank>
                    </template>
                    <template v-else>
                      <essay
                        :info="question"
                        :no="indexQ"
                        :readOnly="readOnly"
                        @change="change"
                      ></essay>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="bottomBox d-flex d-flex-center d-flex-middle" v-if="!readOnly && sections.length > 0" >
            <el-button type="primary" size="small" class="baseBtn" v-if="shortTime">{{ shortTimeTxt }}后可以提交</el-button>
            <el-button type="primary" size="small" @click="submit" class="baseBtn" v-if="!shortTime">提交</el-button>
            <el-button size="small" @click="upload" class="baseBtn">上传答题成果</el-button>
            <input
              ref="file"
              type="file"
              @change="uploadFn"
              id="fileBtn"
              style="display: none"
            />
          </div>
          <div class="bottomBox d-flex d-flex-center d-flex-middle" v-if="redo">
            <el-button type="primary" size="small" @click="redoFn" class="baseBtn">重做</el-button>
          </div>
          <!-- 主观题答案 -->
          <div class="imgBox" v-if="dtkPics.length > 0">
            <p class="img_title">上传的答题卡</p>
            <div class="imgs">
              <div class="box" v-for="(dtk, dtk_i) in dtkPics" :key="dtk_i">
                <el-image
                  :src="dtk.url"
                  :preview-src-list="[dtk.url]"
                  class="img"
                  v-if="ImgType(dtk.url)"
                ></el-image>
                <div class="fileBox" v-else>
                  <img
                    :title="fileNameFn(dtk.url)"
                    :src="require('@/assets/images/File.png')"
                    class="fileImg"
                    @click="openFile(dtk.url)"
                  />
                </div>
                <i
                  class="el-icon-error icon"
                  @click="del_img(dtk.url)"
                  v-if="!readOnly"
                ></i>
              </div>
            </div>
          </div>
          <!-- 倒计时 -->
        </div>
        <!-- 答题卡 -->
        <div class="answerBox">
          <div class="timeBox d-flex d-flex-middle d-flex-center" v-if="time">
            <p>离考试结束还剩</p>
            <b>{{ timeTxt }}</b>
          </div>
          <cardList
            :list="sections"
            @submit="submit"
            @upload="upload"
            @position="position"
            :readOnly="readOnly"
            :showUpload="readOnly"
            :shortTime="shortTime"
            :shortTimeTxt="shortTimeTxt"
          ></cardList>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <camera v-if="need_camera" ref="camera" type="paper" size="mini" @logPhoto_ok="logPhoto_ok" @logPhoto_no="logPhoto_no" />
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import choice from "@/components/question/choice.vue";
import blank from "@/components/question/blank.vue";
import essay from "@/components/question/essay.vue";
import cardList from "@/components/question/cardList.vue";
import camera from "@/components/camera.vue";
import { getServerCurrentTime } from "@/utils/utils.js";
export default {
  components: {
    HeaderTop,
    Footer,
    choice,
    blank,
    essay,
    cardList,
    camera,
  },
  data() {
    return {
      type:'',
      paperId: "",
      examDataId:"",
      // 
      paperData:{},
      courseId:'',
      // 
      shortTime:'',
      shortTimeTxt:'',
      // 
      time:'',
      timeTxt:'',
      // 
      //
      dtkPics: [],
      t: "", //答题保存
      //
      photoInterval: "", //抓拍间隔时间
      // 
      redo: false,
      readOnly: false,
      sections: [],
      //
      //
      need_camera: false,
      //
      activeData: {},
      //
      minSubmitTime: '', // 最短交卷时间
      continuousNoFaceCount: 0
    };
  },
  created() {
    this.type = this.$route.query.type
    this.paperId = this.$route.query.id
    this.examDataId = this.$route.query.examDataId
    this.getInfo()

    this.makeInfo(this.sections, {});
  },
  beforeDestroy() {
    if (this.t) {
      clearInterval(this.t);
      this.t = null;
    }
    if (this.shortTimeTxt) {
      clearInterval(this.shortTimeTxt);
      this.shortTimeTxt = null;
    }
    this.$refs.camera.close();
  },
  methods: {
    toRouter(path) {
      this.$router.push({ path })
    },
    goBack() {
      this.$router.back()
    },
    numToCapital(num, type) {
      if (!num) return 0;
      const strNum = Number((num + "").replace(/[,，]*/g, "")) + ""; // 记录字符
      num = parseInt(Number(strNum)); // 转为整数，
      let capitalAr = "零一二三四五六七八九十";
      let unitAr = [
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
        "十",
        "百",
        "千",
      ];
      if (type) {
        capitalAr = "零壹贰叁肆伍陆柒捌玖拾";
        unitAr = [
          "拾",
          "佰",
          "仟",
          "万",
          "拾",
          "佰",
          "仟",
          "亿",
          "拾",
          "佰",
          "仟",
        ]; // 单位
      }
      const resultAr = []; // 记录结果，后边json.in就可
      let index = strNum.length - 1; //记录位数
      let idx = 0; // 记录单位
      let percent = 10;
      const turnNum = (num, percent, index) => {
        const unit = num / percent;
        const capital = capitalAr[Number(strNum[index])];
        if (unit < 1) {
          resultAr.push(capital);
          // 出现11【一十一】这种情况
          if (
            Number(strNum[index]) === 1 &&
            (strNum.length === 2 || strNum.length === 6 || strNum.length === 10)
          ) {
            resultAr.pop();
          }
          return false; //结束递归
        } else {
          if (capital === "零") {
            // 万和亿单位不删除
            if (!["万", "亿"].includes(resultAr[resultAr.length - 1])) {
              resultAr.pop();
            }
            // 前面有零在删掉一个零
            if (resultAr[resultAr.length - 1] === "零") {
              resultAr.pop();
            }
          }
          resultAr.push(capital);
          // 过滤存在【零万】【零亿】这种情况
          if (
            ["万", "亿"].includes(resultAr[resultAr.length - 2]) &&
            capital === "零"
          ) {
            resultAr.pop();
          }
          // 过滤【1亿万】这种情况
          if (resultAr[0] === "万" && resultAr[1] === "亿") {
            resultAr.shift();
          }
          // 末尾【零】删掉
          if (resultAr[0] === "零") {
            resultAr.pop();
          }
          resultAr.push(unitAr[idx++]);
          turnNum(num, percent * 10, --index);
        }
      };
      turnNum(num, percent, index);
      return resultAr.reverse().join("");
    },
    formatSeconds(time) {
      var d = Math.floor(time / (60 * 60 * 24));
      var h = Math.floor((time / 60 / 60) % 24);
      h = d*24 + h
      h = h > 9 ? h : "0" + h;
      var m = Math.floor((time / 60) % 60);
      m = m > 9 ? m : "0" + m;
      var s = Math.floor(time % 60);
      s = s > 9 ? s : "0" + s;
      return h + ":" + m + ":" + s;
    },
    setShortTime(duration, examStartTime, serverNow) {
      var that = this;
      var givenDate = new Date(examStartTime);
      getServerCurrentTime(that.$http).then((currentDate) => {
        var timeDifference = currentDate.getTime() - givenDate.getTime();
        // 将毫秒差值转换为秒
        var secondsDifference = timeDifference / 1000;

        var remainTime = duration*60 - parseInt(secondsDifference)

        if(remainTime <= 0){ //提交
          that.shortTime = null;
        }else{
          clearInterval(that.shortTime);
          that.shortTime = setInterval(() => {
            remainTime--;
            if (remainTime > 0) {
              that.shortTimeTxt = that.formatSeconds(remainTime);
            } else if( remainTime == 0) {
              clearInterval(that.shortTime);
              that.shortTime = null;
            }
          }, 1000);
        }
      });
    },
    setTimeFn(duration, examStartTime, serverNow){
      var that = this;
      var givenDate = new Date(examStartTime);
      getServerCurrentTime(that.$http).then((currentDate) => {
        var timeDifference = currentDate.getTime() - givenDate.getTime();
        // 将毫秒差值转换为秒
        var secondsDifference = timeDifference / 1000;

        var remainTime = duration*60 - parseInt(secondsDifference)
        
        if(remainTime <= 0){ //提交
          that.submitFn()
        }else{
          clearInterval(that.time);
          that.time = setInterval(() => {
            remainTime--;
            if (remainTime > 0) {
              that.timeTxt = that.formatSeconds(remainTime);
            } else if( remainTime == 0) {
              clearInterval(that.time);
              that.time = null;
              that.submitFn()
            }
          }, 1000);
        }
      });
    },
    async getInfo() {
      var that = this;
      const serverNow = await getServerCurrentTime(this.$http)
      this.$http.get("/student/app/paper/info", { paperId: this.paperId,examDataId: this.examDataId ,type:1}).then((res) => {
        this.courseId = res.courseId
        // 最短交卷时间
        let subTime = 0
        if (res.category == "HOMEWORK") {
          subTime = res.examConfig.assignmentMinSubmitTime || 0
        } else 
        if (res.category == "EXAMINE") {
          subTime = res.examConfig.examMinSubmitTime || 0
        }
        this.setShortTime(subTime, res.exam?.startTime, serverNow)
        // 考试倒计时
        this.paperData = res
        this.makeInfo(res.sections, res.answers);
        this.dtkPics = res.answerCards || [];
        if(res.exam && res.exam.startTime){
          this.setTimeFn(res.duration, res.exam.startTime, serverNow);
        }
        // 答题保存
        this.t = setInterval(() => {
          this.save();
        }, 60000);
        // 抓拍
        const studyConfig=res.studyConfig||{}
        if (studyConfig.openProcessCapture) {
          that.open_camera()
          that.photoInterval = 60*(studyConfig.captureInterval||1);
          that.logPhoto_ok()
        }
      });
    },
    logPhoto_ok(res) {
      var that = this
      const studyConfig=this.paperData.studyConfig||{}
      // 人脸检测踢出逻辑
      if(res&&studyConfig.kickVerify && studyConfig.kickVerify > 0){
        if(res.hasFace === 1){
          // 检测到人脸，重置连续未检测计数
          this.continuousNoFaceCount = 0
        }else{
          // 未检测到人脸，计数加1
          this.continuousNoFaceCount++
          // 达到踢出阈值
          if(this.continuousNoFaceCount >= studyConfig.kickVerify){
            setTimeout(() => {
              this.$alert(`连续${studyConfig.kickVerify}次未检测到人脸，请重新进入学习`,'提示');
            }, 500);
            this.$router.go(-1)
          }
        }
      }
      setTimeout(() => {
        that.$refs.camera.takePhoto({
          examDataId: that.examDataId,
          courseId: that.courseId,
          paperId: that.paperId,
        });
      }, that.photoInterval * 1000);
    },
    logPhoto_no() {
      this.$refs.camera.close();
      this.$router.go(-1);
    },
    makeInfo(res, answers) {
      //处理数据格式
      var that = this;
      res.map((item, index) => {
        item.type = item.questions[0].type;
        item.questions.map((v, i) => {
          if (v.type == "SINGLECHOICE" || v.type == "JUDGMENT") {
            // 单选、判断
            v.myAnswer = answers[v.id] ? answers[v.id] : "";
          } else if (v.type == "MULTIPLECHOICE") {
            //多选
            v.myAnswer = answers[v.id] ? answers[v.id].split("") : [];
          } else if (v.type == "BLANKFILL") {
            //填空
            v.myAnswer = [];
            if (answers[v.id]) {
              v.myAnswer = answers[v.id].split("`");
            } else {
              v.blanks.map((x) => {
                v.myAnswer.push("");
              });
            }
          } else if (item.type == "TT") {
            //套题
            v.children.map((v_, i_) => {
              if (v_.type == "SINGLECHOICE" || v_.type == "JUDGMENT") {
                // 单选、判断
                v_.myAnswer = answers[v_.id] ? answers[v_.id] : "";
              } else if (v_.type == "MULTIPLECHOICE") {
                //多选
                v_.myAnswer = answers[v_.id] ? answers[v_.id].split("") : [];
              } else if (v_.type == "BLANKFILL") {
                //填空
                v_.myAnswer = [];
                if (answers[v_.id]) {
                  v_.myAnswer = answers[v_.id].split("`");
                } else {
                  v_.blanks.map((x) => {
                    v_.myAnswer.push("");
                  });
                }
              } else {
                //文本
                v_.myAnswer = answers[v_.id] ? answers[v_.id] : "";
              }
            });
          } else {
            //文本
            v.myAnswer = answers[v.id] ? answers[v.id] : "";
          }
        });
      });
      this.sections = res;
    },
    save() {
      var answerData = this.makeData()
      if(Object.keys(answerData).length == 0){
        return
      }
      this.$http.post_s("/student/pc/work/save", {isSubmit:0,examDataId: this.examDataId,answerData:answerData}).then((res) => {});
    },
    submitFn() {
      var answerData = this.makeData()
      this.$http.post("/student/pc/work/save", {isSubmit:1,examDataId: this.examDataId,answerData:answerData}).then((res) => {
        window.sessionStorage.removeItem(this.paperId)
        this.$message.success("提交成功");
        this.$router.go(-1);
      });
    },
    ImgType(url) {
      const lastDotIndex = url.lastIndexOf(".");
      if (lastDotIndex === -1) {
        return null; // URL中没有文件扩展名
      }
      const fileExtension = url.slice(lastDotIndex + 1);
      if (
        fileExtension == "jpg" ||
        fileExtension == "png" ||
        fileExtension == "jpeg"
      ) {
        return true;
      } else {
        return false;
      }
    },
    fileNameFn(url) {
      const lastSlashIndex = url.lastIndexOf("/");
      if (lastSlashIndex === -1) {
        return null; // URL中没有文件名
      }
      const fileName = url.slice(lastSlashIndex + 1);
      return fileName;
    },
    openFile(url) {
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.download = this.fileNameFn(url);
      a.style.display = "none";
      document.body.append(a);
      a.click();
      document.body.removeChild(a); // 移除
    },
    reformHtml(html) {
      var reg = new RegExp("\\[BlankArea\\d]", "g");
      html = html.replace(reg, "____");
      return html.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
    },
    change(data) {
      var oldArr = JSON.parse(JSON.stringify(this.sections))
      oldArr.map((v) => {
          v.questions.map((v_) => {
            if (v_.id == data.id) {
              v_.myAnswer = data.value;
            }
            if (v_.children) {
              v_.children.map((x) => {
                if (x.id == data.id) {
                  x.myAnswer = data.value;
                }
              });
            }
          });
        });
        this.sections = oldArr
    },
    position(id) {
      //答题卡锚点定位
      const anchorEle = document.querySelector("#Q-" + id);
      if (!!anchorEle) {
        // anchorEle.scrollIntoView(true);
        var rect = anchorEle.getBoundingClientRect();
          window.scrollTo(0,rect.top + window.scrollY-120);
      }
    },
    upload() {
      document.getElementById("fileBtn").click();
    },
    uploadFn(e) {
      //上传答题卡
      var that = this
      const formData = new FormData();
      formData.append("file", this.$refs.file.files[0]);
      that.$http.post("/student/pc/common/uploadFile2", formData, {"Content-Type": "multipart/form-data"}).then((r) => {
        that.$http.post("/student/pc/paper/uploadAnswerCard", {url: r,examDataId: that.examDataId}).then((res) => {
          that.dtkPics.push({url:r});
          setTimeout(() => {
            e.target.value = null; //相同图片不会触发事件
          }, 500);
        });
      });
    },
    del_img(url) {
      //删除答题卡
      var that = this;
      this.$alert(
        '<p">确定要删除此张答题卡吗（注意：此操作无法恢复）？</p>',
        "提示",
        {
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          callback: (res) => {
            if (res == "confirm") {
              var pamars = {
                examDataId: this.examDataId,
                url: url
              };
              that.$http.post("/student/pc/paper/deleteAnswerCard", pamars).then((res) => {
                var index = that.dtkPics.findIndex((v) => {
                  return v.url == url;
                });
                that.dtkPics.splice(index, 1);
              });
              
              // 
            }
          },
        }
      );
    },
    submit() {
      //提交
      var doOver = this.doOver();
      var txt = "";
      if (!doOver) {
        this.type == 'HOMEWORK'?txt ='作业还未做完，':txt ='试卷还未做完，'
      }
      this.$alert("<p>" + txt + "是否确定提交？</p>", "提示", {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        callback: (res) => {
          if (res == "confirm") {
            this.submitFn()
          }
        },
      });
    },
    doOver() {
      var status = true;
      this.sections.map((v, i) => {
        v.questions.map((item, index) => {
          if ((item.type == "SINGLECHOICE" || item.type == "JUDGMENT") && item.myAnswer == "") {
            // 单选、判断
            status = false;
          } else if (item.type == "MULTIPLECHOICE" && item.myAnswer == []) {
            //多选
          } else if (item.type == "BLANKFILL") {
            //填空
            var x = item.myAnswer.every((x) => x != "");
            if (!x) {
              status = false;
            }
          } else if (item.type == "TT") {
            //套题
            item.children.map((v_, i_) => {
              if ((v_.type == "SINGLECHOICE" || v_.type == "JUDGMENT") && v_.myAnswer == "") {
                // 单选、判断
                status = false;
              } else if (v_.type == "MULTIPLECHOICE" && v_.myAnswer != []) {
                //多选
                status = false;
              } else if (v_.type == "BLANKFILL") {
                //填空
                var cx = v_.myAnswer.every((cx) => cx != "");
                if (!cx) {
                  status = false;
                }
              } else {
                //文本
                if (v_.myAnswer == "") {
                  status = false;
                }
              }
            });
          } else {
            //文本
            if (item.myAnswer == "") {
              status = false;
            }
          }
        });
      });
      return status;
    },
    makeData() { //提取做答题目，转为接口需要的格式
      var answers = {};
      this.sections.map((v, i) => {
        v.questions.map((item, index) => {
          if ((item.type == "SINGLECHOICE" || item.type == "JUDGMENT") && item.myAnswer != "") {
            // 单选、判断
            answers[item.id] = item.myAnswer;
          } else if (item.type == "MULTIPLECHOICE" && item.myAnswer != []) {
            //多选
            answers[item.id] = item.myAnswer.join("");
          } else if (item.type == "BLANKFILL") {
            //填空
            answers[item.id] = item.myAnswer.join("`");
          } else if (item.type == "TT") {
            //套题
            item.children.map((v_, i_) => {
              if ((v_.type == "SINGLECHOICE" || v_.type == "JUDGMENT") && v_.myAnswer != "") {
                // 单选、判断
                answers[v_.id] = v_.myAnswer;
              } else if (v_.type == "MULTIPLECHOICE" && v_.myAnswer != []) {
                //多选
                answers[ v_.id] = v_.myAnswer.join("");
              } else if (v_.type == "BLANKFILL") {
                //填空
                answers[v_.id] = v_.myAnswer.join("`");
              } else {
                //文本
                if (v_.myAnswer != "") {
                  answers[v_.id] = v_.myAnswer;
                }
              }
            });
          } else {
            //文本
            if (item.myAnswer != "") {
              answers[item.id] = item.myAnswer;
            }
          }
        });
      });
      return answers;
    },
    open_camera() {
      this.need_camera = true;
    },
    redoFn() {
      //重做
      this.$confirm("确定要重做（点击“确定”按钮后会清空这个成绩）？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (res == "confirm") {
          this.$emit("redo");
        }
      });
    },
    
  },
};
</script>
<style lang="scss" scoped>
.paperPage {
  padding-top: 90px;
  min-height: calc(100% - 200px);
  font-size: 14px;
  p{
    margin: 0;
  }
  .mianbao{
        color: #666;
    margin-bottom: 20px;
        .bread {
          display: flex;
          align-items: center;
        }
        .dq {
          color: #999;
        }
        .mba, .site {
          color: #666;
        }
        .click {
          color: #409EFF;
          cursor: pointer;
        }
        .click:hover {
          text-decoration: underline;
        }
        .backBtn {
          color: #666;
          background: #fff;
          border: 1px solid #dcdfe6;
        }
        .backBtn:hover {
          color: #409EFF;
          border-color: #409EFF;
        }
      }
  .mid {
    width: 1200px;
    margin: 0 auto 30px auto;
    overflow: hidden;
    min-height: calc(100vh - 310px);
    .content {
      width: 830px;
      background: #ffffff;
      box-shadow: 0px 3px 10px 0px rgba(153, 153, 153, 0.25);
      border-radius: 10px;
      box-sizing: border-box;
      padding: 30px 0;
    }
    .paperInfo {
      .paperTitle {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: #333;
      }
      .descBox {
        margin: 20px auto;
        p {
          margin: 0 30px;
          font-size: 14px;
          color: #999999;
        }
      }
      .scoreTable {
        width: 90%;
        margin: 10px auto;
        table {
          width: 100%;
          border: 1px solid;
          border-collapse: collapse;
          border-spacing: 10px 50px;
          td {
            border: 1px solid #c2c2c2;
            color: #666;
            font-size: 14px;
            padding: 5px;
            line-height: 22px;
            &:nth-of-type(1) {
              width: 60px;
            }
          }
        }
      }
    }
    .paperBox {
      width: 90%;
      margin: 0 auto;
      .list {
        .li {
          background: #fff;
          margin-bottom: 15px;
          border-bottom: 1px solid #F2F2F2;
          .titleBox {
            box-sizing: border-box;
            padding: 10px 0;
          }
          .liBox {
            margin: 20px 0;
            position: relative;
            .functionBox {
              position: absolute;
              top: -7.5px;
              right: 0;
              background: #fff;
              box-sizing: border-box;
              padding: 5px 10px;
              border-radius: 5px;
              box-shadow: 0 0 10px #ddd;
              z-index: 22;
              .collectBox {
                margin-left: 10px;
                img {
                  width: 24px;
                  height: 24px;
                }
              }
            }
            .boxView {
              position: relative;
              .functionBox {
                top: 0;
              }
            }
          }
        }
      }
    }
    .answerBox {
      width: 320px;
      box-sizing: border-box;
      padding: 0 10px;
      box-shadow: 0px 3px 10px 0px rgba(153, 153, 153, 0.25);
      border-radius: 10px;
      right: calc(50% - 600px);
      position: fixed;
      top: 170px;
      background: #fff;
      z-index: 99;
      overflow: hidden;
      .timeBox{
        height: 80px;
        border-bottom: 1px solid #f2f2f2;
        font-size: 16px;
        b{
          color: #FFA800;
          font-size: 34px;
          margin-left: 10px;
          font-weight: 500;
        }
      }
    }
    .bottomBox {
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
      .uploadBtn {
        margin-left: 15px;
      }
    }
    .imgBox {
      box-sizing: border-box;
      padding: 0 10px;
      border: 1px solid #ddd;
      border-radius: 5px;
      background: #fff;
      margin-bottom: 15px;
      width: 90%;
      margin: 30px auto;
      .img_title {
        box-sizing: border-box;
        padding: 10px;
        border-bottom: 1px solid #eee;
      }
      .imgs {
        display: flex;
        justify-items: center;
        flex-wrap: wrap;
        .box {
          box-shadow: 0 0 1px;
          margin: 10px;
          position: relative;
          border-radius: 5px;
          width: 100px;
          height: 100px;
          .img {
            width: 100%;
            height: 100%;
            border-radius: 5px;
            cursor: pointer;
          }
          .fileBox {
            width: 100%;
            height: 100%;
            img {
              width: 60%;
              height: 60%;
              position: relative;
              top: 20%;
              left: 20%;
              cursor: pointer;
            }
          }
          .icon {
            position: absolute;
            top: -8px;
            right: -8px;
            font-size: 20px;
            color: red;
            cursor: pointer;
            background: #fff;
            border-radius: 50%;
          }
        }
      }
    }
    .scoreBox {
      height: 16px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
  }
}
</style>
  